"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.ArrowChevronRight = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.99805 8.00293L5.99707 5.00195C5.99707 4.62825 6.10189 4.37305 6.31152 4.23633C6.52116 4.09961 6.71712 4.01986 6.89941 3.99707H7.00195L11.001 8.00293L7.00195 12.002H6.89941C6.53483 11.9701 6.27279 11.7969 6.11328 11.4824C6.03581 11.3594 5.99707 11.1976 5.99707 10.9971L8.99805 8.00293Z",
    clipRule: "evenodd"
  })));
};